const styles = () => ({
    boardWrapper: {
        zIndex: '1',
        position: 'relative',
        margin: '30px auto 0',
        width: '100%',
        paddingBottom: '30px',
        paddingLeft: 0,
        paddingRight: 0,
        minHeight: '450px',
        '@media only screen and (max-width: 1600px)': {
            width: 1160
        },
        '&.assessment-library': {
            width: 1040,
            '@media only screen and (max-width: 1400px)': {
                width: '100%'
            }
        },
        '@media only screen and (max-width: 1400px)': {
            width: '100%'
        }
    },
    jobCount: {
        fontWeight: 600,
        marginBottom: 32
    },
    infiniteScroll: {
        marginBottom: 50,
        textAlign: 'center'
    },
    loader: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        margin: 'auto'
    },
    searchField: {
        marginTop: 33,
        marginBottom: 24
    },
    mansoryWrapper: {
        border: '1px solid #EAECED',
        borderRadius: 4,
        backgroundColor: 'white',
        padding: '30px 15px 0',
        margin: '0 0 30px',
        '& > div': {
            margin: '0 15px 30px'
        }
    },
    helpFooter: {
        maxWidth: 1137
    },
    button: {
        fontWeight: 'bold',
        fontSize: 14,
        lineHeight: '21px',
        textAlign: 'center',
        letterSpacing: '0.2px',
        color: '#FFFFFF',
        padding: '7px 24px',
        boxShadow: 'none'
    },
    searchLoaderWrapper: {
        height: 160,
        position: 'relative'
    }
});

export default styles;
